<a href="" class="container clickable" [ngClass]="type" [ngStyle]="{'background': 'linear-gradient(transparent, #000000d4), url(../../../assets/images/' + image + ')'}">
    <span>{{text}}</span>
</a>